/* import __COLOCATED_TEMPLATE__ from './edit-category-topic-template.hbs'; */
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { schedule } from "@ember/runloop";
import { observes } from "@ember-decorators/object";
import { buildCategoryPanel } from "discourse/components/edit-category-panel";
import discourseComputed from "discourse-common/utils/decorators";

export default class EditCategoryTopicTemplate extends buildCategoryPanel(
  "topic-template"
) {
  @tracked _showFormTemplateOverride;

  get showFormTemplate() {
    return (
      this._showFormTemplateOverride ??
      Boolean(this.category.get("form_template_ids.length"))
    );
  }

  set showFormTemplate(value) {
    this._showFormTemplateOverride = value;
  }

  @discourseComputed("showFormTemplate")
  templateTypeToggleLabel(showFormTemplate) {
    if (showFormTemplate) {
      return "admin.form_templates.edit_category.toggle_form_template";
    }

    return "admin.form_templates.edit_category.toggle_freeform";
  }

  @action
  toggleTemplateType() {
    this.toggleProperty("showFormTemplate");

    if (!this.showFormTemplate) {
      // Clear associated form templates if switching to freeform
      this.set("category.form_template_ids", []);
    }
  }

  @observes("activeTab", "showFormTemplate")
  _activeTabChanged() {
    if (this.activeTab && !this.showFormTemplate) {
      schedule("afterRender", () =>
        this.element.querySelector(".d-editor-input").focus()
      );
    }
  }
}
